import { render, staticRenderFns } from "./pending-records.vue?vue&type=template&id=a6ae1ce6&scoped=true"
import script from "./pending-records.vue?vue&type=script&lang=js"
export * from "./pending-records.vue?vue&type=script&lang=js"
import style0 from "./pending-records.vue?vue&type=style&index=0&id=a6ae1ce6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ae1ce6",
  null
  
)

export default component.exports